import { gql } from '@/shared/graphql/generated/cache';

export const getAllEnvironmentAddressesQuery = gql(/* GraphQL */ `
  query GetAllEnvironmentAddresses {
    allEnvironmentAddresses {
      nodes {
        redemptionTax
      }
    }
  }
`);
